module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_bg_3.cd2a0f89.png";